<template>            
    <div class="social-icon">
        <a v-on:click="recordLead" v-bind:href="network.profileUrl" target="_blank">                   
            <img v-if="network.network === 'linkedin'" src="../assets/icons/linkedin.svg">
            <img v-else-if="network.network === 'facebook'" src="../assets/icons/facebook.svg">        
            <img v-else-if="network.network === 'twitter'" src="../assets/icons/twitter.svg">
        </a>               
    </div>
</template>

<script>
import {LeadBus} from '../router/index';
export default {
    props: {
        network: {},
        attendee: {}
    },

    methods: {
        recordLead() {
            LeadBus.$emit('recordLead', {type: 'attendee-profile-link', data: {network: this.network.network, userId: this.attendee.id}});
        }
    }
};

</script>

<style lang="scss">

.social-icon {
    margin: 20px 0 0 10px; 
    
    img {
        cursor: pointer;
        width: 21.95px;
        height: 25.6px;                      
    }
}

</style>


// WEBPACK FOOTER //
// SocialIcons.vue?934216e8